import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
//import { useSelector } from "react-redux";
import trans from "../../../utils";

import { popupcontext } from "../../../context/Popupscontext";
import {
	useGetAllDevicesQuery,
	useGetUsersDeviceQuery,
} from "../../../Redux/Devicestwo";

export default function VehiclesMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	//const inf = useSelector((state) => state.users.user);
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedVehicles, setSelectedVehicles] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AllDevices, refetch: AllDevicesReftech } = useGetAllDevicesQuery(
		undefined,
		{ refetchOnMountOrArgChange: true }
	);

	let { data: UsersDevices, refetch: UsersDevicesRefetch } =
		useGetUsersDeviceQuery(userId, {
			skip: !userId,
			refetchOnMountOrArgChange: true,
		});

	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AllDevices && UsersDevices) {
			const merged = [...AllDevices, ...UsersDevices];
			const unique = merged.filter(
				(item, index, self) => index === self.findIndex((t) => t.id === item.id)
			);
			setMergedData(unique);
		}
	}, [AllDevices, UsersDevices]);
	useEffect(() => {
		if (isFirstMount.current || AllDevicesReftech || UsersDevicesRefetch) {
			if (mergedData?.length > 0) {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.name,
					}))
				);
			}
		}
		isFirstMount.current = false;
	}, [mergedData, AllDevicesReftech, UsersDevices, UsersDevicesRefetch]);

	useEffect(() => {
		if (type === "users") {
			if (UsersDevices) {
				setSelectedVehicles(UsersDevices?.map((i) => i.id));
			}
		}
	}, [UsersDevices, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "users") {
				UsersDevicesRefetch();
			}
		}
	}, [isLinking, type, UsersDevicesRefetch]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedVehicles((prev) => [...prev, value]);
						handleLink(value, "device", "Vehicle");
					}}
					onDeselect={(value) => {
						setSelectedVehicles((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "device", "Vehice");
					}}
					value={mergedData?.length > 0 ? selectedVehicles : undefined}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
